export const CHAT_MODE_CATEGORIES = [
    { key: 'pre', control: 'frequency', time: '09:00', phrases: 5 },
    { key: 'post', control: 'frequency', time: '20:00', phrases: 5 },
    { key: 'weekly', control: 'weekday', time: '19:00', phrases: 5 },
    { key: 'payment', control: 'moment', time: '09:00', phrases: 2 },
]

export const CHAT_MODE_FREQUENCIES = [25, 50, 75, 100]

export const CHAT_MODE_PAYMENT_MOMENTS = ['month_end_3', 'month_first']

export const CHAT_MODE_DEFAULT_WEEKDAY = 7

const DEFAULT_FREQUENCY = 100

export function chatModeConfigId(coachId, studentId) {
    if (!coachId || !studentId) return null
    return `${coachId}_${studentId}`
}

export function newPhraseId() {
    return `p${Date.now()}${Math.floor(Math.random() * 1000)}`
}

function defaultPhrases(category, translate) {
    const phrases = []
    for (let i = 1; i <= category.phrases; i++) {
        phrases.push({ id: `${category.key}_${i}`, text: translate(`chatMode.default_${category.key}_${i}`) })
    }
    return phrases
}

function defaultCategory(category, translate) {
    const phrases = defaultPhrases(category, translate)
    const value = {
        phrases,
        active: [],
        time: category.time,
    }
    if (category.control === 'frequency') value.frequency = DEFAULT_FREQUENCY
    if (category.control === 'weekday') value.weekday = CHAT_MODE_DEFAULT_WEEKDAY
    if (category.control === 'moment') value.when = CHAT_MODE_PAYMENT_MOMENTS[0]
    return value
}

export function normalizeChatModeConfig(data, translate) {
    const stored = data || {}
    const config = { enabled: !!stored.enabled }
    for (const category of CHAT_MODE_CATEGORIES) {
        const base = defaultCategory(category, translate)
        const saved = stored[category.key] || {}
        const phrases = Array.isArray(saved.phrases) ? saved.phrases : base.phrases
        config[category.key] = {
            ...base,
            ...saved,
            phrases: phrases.map(item => ({ id: item.id, text: item.text })),
            active: (saved.active || []).filter(id => phrases.some(item => item.id === id)),
        }
    }
    return config
}

export function chatModeTriggerHours(config) {
    const hours = new Set()
    if (!config?.enabled) return []
    for (const category of CHAT_MODE_CATEGORIES) {
        const value = config[category.key]
        if (!value?.active?.length) continue
        hours.add(String(value.time || category.time).slice(0, 2))
    }
    return [...hours]
}

export function chatModePayload(config, coachId, studentId) {
    const payload = {
        coachId,
        studentId,
        enabled: !!config.enabled,
        triggerHours: chatModeTriggerHours(config),
    }
    for (const category of CHAT_MODE_CATEGORIES) {
        const value = config[category.key]
        const stored = {
            phrases: value.phrases.map(item => ({ id: item.id, text: item.text })),
            active: [...value.active],
            time: value.time,
        }
        if (category.control === 'frequency') stored.frequency = value.frequency
        if (category.control === 'weekday') stored.weekday = value.weekday
        if (category.control === 'moment') stored.when = value.when
        payload[category.key] = stored
    }
    return payload
}
